/* Size guide + recommendation (5.5.0).
   Every [data-size-system] has two tabs: the chart and "Find your size". The finder reads its guide's
   `rules` lines ([data-sg-rule]) — simple form "طول 160-170 = M" / "وزن 60-75 = L" (height and weight
   rules are independent; when both match, the larger size wins), or the classic "M,165-175[,55-68]" —
   and falls back to the height / weight ranges in the table ([data-size-row], an estimate).
   "Select this size" ticks the real size option: the product form, or the first piece in the Customizer. */
(() => {
  const AR = '٠١٢٣٤٥٦٧٨٩', FA = '۰۱۲۳۴۵۶۷۸۹';
  const latin = (v) => String(v || '').replace(/[٠-٩]/g, (d) => AR.indexOf(d)).replace(/[۰-۹]/g, (d) => FA.indexOf(d));
  const norm = (v) => String(v || '').trim().toUpperCase().replace(/^XXXXL$/, '4XL').replace(/^XXXL$/, '3XL').replace(/^XXL$/, '2XL');
  const RANK = ['XXS', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'];
  const rank = (s) => { const i = RANK.indexOf(norm(s)); return i < 0 ? 99 : i; };
  const range = (v) => { const m = latin(v).match(/(\d+(?:\.\d+)?)\s*[-–—]\s*(\d+(?:\.\d+)?)/); return m ? [+m[1], +m[2]] : [0, 0]; };
  const dist = (v, lo, hi) => (v < lo ? lo - v : v > hi ? v - hi : Math.abs(v - (lo + hi) / 2) / 1000);
  const num = (v) => Number(latin(v).replace(',', '.'));
  const KG = /وزن|الوزن|weight|كجم|كيلو|kg/i;
  const LESS = /أقل|اقل|تحت|حتى|لحد|less|under|below|up to|<|≤/i;

  /* One rule line → [{ kind: 'h' | 'w', size, lo, hi }]. */
  const parseRule = (raw) => {
    const t = latin(raw).replace(/\s+/g, ' ').trim();
    if (!t) return [];
    const eq = t.match(/^(.*?)\s*(?:=|:|→|←)\s*(.*)$/);
    if (eq) {
      let a = eq[1], b = eq[2];
      if (!/\d{2,}/.test(a) && /\d{2,}/.test(b)) [a, b] = [b, a];
      const size = b.replace(/المقاس|مقاس|size/gi, '').trim().split(' ')[0];
      const n = (a.match(/\d+(?:\.\d+)?/g) || []).map(Number);
      if (!size || !n.length) return [];
      let lo, hi;
      if (n.length >= 2) { lo = Math.min(n[0], n[1]); hi = Math.max(n[0], n[1]); }
      else if (LESS.test(a)) { lo = 0; hi = n[0]; }
      else { lo = n[0]; hi = 999; }
      return [{ kind: KG.test(a) ? 'w' : 'h', size, lo, hi }];
    }
    const c = t.split(/\s*[,|،]\s*/);
    if (c.length < 2 || !c[0]) return [];
    const out = [], [lo, hi] = range(c[1]), [wlo, whi] = range(c[2]);
    if (hi) out.push({ kind: 'h', size: c[0], lo, hi });
    if (whi) out.push({ kind: 'w', size: c[0], lo: wlo, hi: whi });
    return out;
  };
  window.LINUXSizeRule = parseRule;

  const setTab = (sys, name) => {
    if (!sys.querySelector(':scope > [data-sg-panel="' + name + '"]')) return;
    sys.querySelectorAll(':scope > .sg-tabs [data-sg-tab]').forEach((b) => {
      const on = b.dataset.sgTab === name;
      b.classList.toggle('is-active', on); b.setAttribute('aria-selected', String(on)); b.tabIndex = on ? 0 : -1;
    });
    sys.querySelectorAll(':scope > [data-sg-panel]').forEach((p) => { p.hidden = p.dataset.sgPanel !== name; });
  };

  const init = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const drawer = root.closest('[data-drawer]');
    const sys = root.closest('[data-size-system]') || drawer || document;
    const $ = (s) => root.querySelector(s);
    const arDigits = /[٠-٩]/.test(sys.textContent);
    const dg = (n) => (arDigits ? String(n).replace(/\d/g, (d) => AR[d]) : String(n));

    let rules = [...sys.querySelectorAll('[data-sg-rule]')].flatMap((el) => parseRule(el.dataset.sgRule));
    if (!rules.length) {
      rules = [...sys.querySelectorAll('[data-size-row]')].flatMap((el) => {
        const s = (el.dataset.size || '').trim(), [lo, hi] = range(el.dataset.h), [wlo, whi] = range(el.dataset.w), o = [];
        if (s && hi) o.push({ kind: 'h', size: s, lo, hi });
        if (s && whi) o.push({ kind: 'w', size: s, lo: wlo, hi: whi });
        return o;
      });
    }
    if (!rules.length) {
      const form = $('[data-sf-form]'), nd = $('[data-sf-nodata]');
      if (form && nd) { form.hidden = true; nd.hidden = false; } else root.hidden = true;
      return;
    }
    const H = rules.filter((r) => r.kind === 'h'), WR = rules.filter((r) => r.kind === 'w');
    const weightFirst = !H.length;
    const order = [];
    const add = (s) => { if (s && !order.some((o) => norm(o) === norm(s))) order.push(s); };
    sys.querySelectorAll('[data-size-tr]').forEach((tr) => add(tr.dataset.sizeTr));
    [...rules].sort((a, b) => rank(a.size) - rank(b.size)).forEach((r) => add(r.size));
    const ix = (s) => order.findIndex((o) => norm(o) === norm(s));
    const best = (list, v) => {
      let r = null, d = Infinity;
      list.forEach((x) => { const k = dist(v, x.lo, x.hi); if (k < d) { d = k; r = x; } });
      return r && { ...r, inside: v >= r.lo && v <= r.hi };
    };
    const fmt = (r) => (r.lo <= 0 ? '≤ ' + dg(r.hi) : r.hi >= 999 ? dg(r.lo) + '+' : dg(r.lo) + '–' + dg(r.hi));

    let style = 'oversized';
    root.querySelectorAll('[data-sf-style]').forEach((b) => b.addEventListener('click', () => {
      style = b.dataset.sfStyle;
      root.querySelectorAll('[data-sf-style]').forEach((x) => { const on = x === b; x.classList.toggle('is-active', on); x.setAttribute('aria-checked', String(on)); });
    }));
    const known = (i) => order.some((s) => norm(s) === norm(i.value));
    const czInputs = () => {
      const list = document.querySelector('[data-cz-sizes-list]');
      if (!list || list.classList.contains('is-matrix')) return [];
      const row = list.querySelector('[role="radiogroup"]');
      return row ? [...row.querySelectorAll('input[type="radio"]')] : [];
    };
    const sizeInputs = () => {
      const p = [...document.querySelectorAll('main [data-option-input]')].filter((i) => !i.closest('.pdp--quick') && !i.closest('[data-drawer]') && known(i));
      return p.length ? p : czInputs().filter(known);
    };
    const hIn = $('[data-sf-height]'), wIn = $('[data-sf-weight]'), err = $('[data-sf-err]'), res = $('[data-sf-result]');
    if (weightFirst) {
      wIn.closest('label')?.querySelector('small')?.remove();
      const hl = hIn.closest('label'); if (hl && !hl.querySelector('small')) hl.querySelector('.field__label')?.insertAdjacentHTML('beforeend', ' <small class="muted"></small>');
    }
    const clear = () => { err.hidden = true; [hIn, wIn].forEach((i) => { i.classList.remove('is-invalid'); i.removeAttribute('aria-invalid'); }); };
    const fail = (input, msg) => {
      err.textContent = msg; err.hidden = false; res.hidden = true;
      input.classList.add('is-invalid'); input.setAttribute('aria-invalid', 'true');
      input.focus({ preventScroll: true }); input.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };
    [hIn, wIn].forEach((i) => i.addEventListener('input', clear));
    root.addEventListener('keydown', (e) => { if (e.key === 'Enter' && e.target.matches('input')) { e.preventDefault(); $('[data-sf-calc]').click(); } });
    $('[data-sf-calc]').addEventListener('click', () => {
      clear();
      const hv = hIn.value.trim(), wv = wIn.value.trim();
      let h = 0, w = 0;
      if (hv) { h = num(hv); if (!(h >= 120 && h <= 230)) return fail(hIn, err.dataset.badH || err.dataset.need); }
      else if (!weightFirst) return fail(hIn, err.dataset.need);
      if (wv) { w = num(wv); if (!(w >= 35 && w <= 200)) return fail(wIn, err.dataset.badW || err.dataset.need); }
      else if (weightFirst) return fail(wIn, err.dataset.needW || err.dataset.need);

      const hs = h && H.length ? best(H, h) : null;
      const ws = w && WR.length ? best(WR, w) : null;
      let i = Math.max(hs ? ix(hs.size) : -1, ws ? ix(ws.size) : -1);
      let bump = 0;
      if (w && !WR.length && hs) { const bmi = w / ((h / 100) ** 2); bump = bmi >= 28 ? 1 : bmi < 19 ? -1 : 0; i += bump; }
      if (style === 'regular') i -= 1;
      i = Math.max(0, Math.min(order.length - 1, i));
      const avail = sizeInputs();
      const ok = (k) => avail.some((x) => norm(x.value) === norm(order[k]));
      if (avail.length && !ok(i)) {
        for (let d = 1; d < order.length; d++) {
          if (i + d < order.length && ok(i + d)) { i += d; break; }
          if (i - d >= 0 && ok(i - d)) { i -= d; break; }
        }
      }
      const size = order[i];
      $('[data-sf-size]').textContent = size;
      const rs = $('[data-sf-reason]'), parts = [];
      const split = hs && ws && norm(hs.size) !== norm(ws.size);
      if (hs) parts.push((rs.dataset.wh || '').replace('[h]', dg(h)).replace('[s]', hs.size).replace('[r]', fmt(hs)));
      if (ws) parts.push((rs.dataset.ww || '').replace('[w]', dg(w)).replace('[s]', ws.size).replace('[r]', fmt(ws)));
      if (split) parts.push(rs.dataset.wb);
      if (bump) parts.push((bump > 0 ? rs.dataset.bu : rs.dataset.bd || '').replace('[w]', dg(w)));
      if (style === 'regular') parts.push(rs.dataset.rreg);
      rs.textContent = parts.filter(Boolean).join(' ');
      const alt = $('[data-sf-alt]');
      const lowIdx = split ? Math.min(ix(hs.size), ix(ws.size)) : bump > 0 ? ix(hs.size) : -1;
      alt.textContent = lowIdx >= 0 && lowIdx !== i ? (alt.dataset.altDown || '').replace('[size]', order[lowIdx])
        : order[i + 1] ? (alt.dataset.alt || '').replace('[size]', order[i + 1])
        : order[i - 1] ? (alt.dataset.altDown || '').replace('[size]', order[i - 1]) : '';
      $('[data-sf-est]').hidden = !(w && !WR.length);
      const out = $('[data-sf-out]'); if (out) out.hidden = (!hs || hs.inside) && (!ws || ws.inside);
      sys.querySelectorAll('[data-size-tr]').forEach((tr) => tr.classList.toggle('is-match', norm(tr.dataset.sizeTr) === norm(size)));
      res.dataset.size = size; res.hidden = false;
      $('[data-sf-select]').hidden = !avail.length;
      const see = $('[data-sf-see]'); if (see) see.hidden = !sys.querySelector('tr.is-match');
      res.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest' });
    });
    $('[data-sf-select]').addEventListener('click', () => {
      const t = sizeInputs().find((x) => norm(x.value) === norm(res.dataset.size));
      if (!t) return;
      t.checked = true;
      t.dispatchEvent(new Event('input', { bubbles: true }));
      t.dispatchEvent(new Event('change', { bubbles: true }));
      drawer?.querySelector('[data-drawer-close]')?.click();
      setTimeout(() => (t.closest('.pill') || t.closest('label') || t).scrollIntoView({ behavior: 'smooth', block: 'center' }), 350);
    });
    $('[data-sf-see]')?.addEventListener('click', () => {
      setTab(sys, 'table');
      const m = sys.querySelector('tr.is-match');
      if (m) setTimeout(() => m.scrollIntoView({ behavior: 'smooth', block: 'center' }), 30);
    });
  };
  document.querySelectorAll('[data-size-finder]').forEach(init);

  if (!window.__sgTabs) {
    window.__sgTabs = true;
    document.addEventListener('click', (e) => {
      const op = e.target.closest?.('[data-drawer-open="size-guide"]');
      if (op) {
        const name = op.dataset.sgTab || 'table';
        document.querySelectorAll('[data-drawer="size-guide"] [data-size-system]').forEach((s) => setTab(s, name));
        const b = document.querySelector('[data-drawer="size-guide"] .drawer__body'); if (b) b.scrollTop = 0;
        return;
      }
      const t = e.target.closest?.('[data-sg-tab]');
      const s = t?.closest('[data-size-system]');
      if (s) { setTab(s, t.dataset.sgTab); const b = t.closest('.drawer__body'); if (b) b.scrollTop = 0; }
    });
    document.addEventListener('keydown', (e) => {
      const t = e.target.closest?.('[data-sg-tab]');
      if (!t || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) return;
      const tabs = [...t.closest('.sg-tabs').querySelectorAll('[data-sg-tab]')];
      const n = tabs.find((x) => x !== t) || t;
      e.preventDefault(); n.click(); n.focus();
    });
  }

  /* Drag the sheet's handle down to close it (phones). One listener, however many guides render. */
  if (!window.__sgGrab) {
    window.__sgGrab = true;
    document.addEventListener('pointerdown', (e) => {
      const g = e.target.closest?.('[data-drawer-grab]');
      if (!g) return;
      const d = g.closest('[data-drawer]'), y0 = e.clientY;
      let dy = 0;
      d.style.transition = 'none';
      const move = (ev) => { dy = Math.max(0, ev.clientY - y0); d.style.transform = `translateY(${dy}px)`; };
      const end = () => {
        removeEventListener('pointermove', move); removeEventListener('pointerup', end); removeEventListener('pointercancel', end);
        d.style.transition = ''; d.style.transform = '';
        if (dy > 90) d.querySelector('[data-drawer-close]')?.click();
      };
      addEventListener('pointermove', move); addEventListener('pointerup', end); addEventListener('pointercancel', end);
    });
  }
})();